import { CssBaseline, ThemeProvider } from '@mui/material';
import { createAppTheme, ToastProvider } from '@myhrbox/myhrbox-frontend-core';
import { DialogProvider } from 'context/dialogContext';
import { ResultModalProvider } from 'context/resultModalContext';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import 'highlight.js/styles/github.css'; // должен быть единый здесь и на платформе
import { RouterProvider } from 'react-router-dom';
import './assets/style.css';
import router from './router';

dayjs.extend(duration);

const theme = createAppTheme();

const App = () => (
  <ThemeProvider theme={theme}>
    <ToastProvider>
      <DialogProvider>
        <ResultModalProvider>
          <CssBaseline />
          <RouterProvider router={router} />
        </ResultModalProvider>
      </DialogProvider>
    </ToastProvider>
  </ThemeProvider>
);

export default App;
